import { get, post } from "../web.request";

export const login = async (data) => {
  return await post(`/adminLogin`, data);
}

export const loadUser = async () => {
  return await post(`/Token`);
}